
export default {
  routeExtras: {
    extras: 'Route extras',
    extraInfo: 'Extra info',
    value: 'Value',
    clickToHighlightOnMap: 'Click to highlight it on map',
    showAllOnMap: 'Show all on map'
  }
}
